import Context from "shared/util/Context";

function trackEvent(eventName, properties = {}) {
	if (window.fbq && typeof window.fbq === "function" && !Context.has("BLOCK_PERSONALIZED_MARKETING")) {
		window.fbq("track", eventName, properties);
	}
}

export default {
	trackEvent,
};



// WEBPACK FOOTER //
// ./src/analytics/util/FBPixel/index.js